import {Directive, ElementRef, HostBinding, NgModule, OnInit, Renderer2} from '@angular/core';
import {LayoutService} from '../../../../layout/src/lib/layout.service';

@Directive({
	selector: '[libApplyTheme]'
})
export class ApplyThemeDirective implements OnInit {
	@HostBinding('class') theme: string;

	constructor(private el: ElementRef, private layout: LayoutService, private renderer: Renderer2) {
	}


	ngOnInit() {
		this.layout.currentTheme$.subscribe(val => {
			if (!val || `theme-${val}` === this.theme) return;

			this.renderer.removeClass(this.el.nativeElement, this.theme);
			this.theme = `theme-${val}`;
		});
	}
}
@NgModule({
	declarations: [ApplyThemeDirective],
	exports: [ApplyThemeDirective]
})
export class ApplyThemeDirectiveModule {}
